module.exports = __webpack_public_path__ + "img/yuxi02.cdfd4e79.png";